import toUpper from 'lodash/toUpper';
import { fetch } from '~helpers/graphql';
import endpoints from '~settings/endpoints';
import * as landlordQueries from '~settings/queries';
import { Hosts } from '~helpers/environments';

const TIMEOUT = 1000 * 60 * 15;

const StripeClientId = {
  PROD: {
    USD: 'ca_DAsjGDr2uMgSO5dhytwC7CDtDlna0wkC',
    AUD: 'ca_D3OS7OTKM8NMyI2or0ss68oXzVLdcLz1',
    GBP: 'ca_BrGKrFeWQhqSvwgD5Z4O8OJGUlU6GuaY',
  },
  STAGE: {
    USD: 'ca_DAsj1265Zhr4Hk115eqKEapsHWlqivkR',
    AUD: 'ca_D3OSufqEtq4XLWEeuW9Z0vIV4iMOsbST',
    GBP: 'ca_BrGKxujjFCMjQYeCJPHFsgiYODcUZAqy',
  },
};

export default class Stripe {
  constructor(currency) {
    this.currency = currency || 'GBP';
    this.stripeUrl = this.getStripeUrl(this.currency);
    this.waitingStripeFunc = null;
  }

  getStripeUrl = currency => {
    const env = toUpper(Hosts.hostName) === 'PROD' ? 'PROD' : 'STAGE';
    const redirectUrl = `${window.location.origin}${process.env.PUBLIC_URL}/withdrawal/callback`;

    let stripeCurrency = '';
    if (currency === 'NZD') {
      stripeCurrency = 'AUD';
    } else if (Object.keys(StripeClientId[env]).includes(currency)) {
      stripeCurrency = currency;
    } else {
      stripeCurrency = 'GBP';
    }
    const stripeId = StripeClientId[env][stripeCurrency];
    return `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${stripeId}&scope=read_write&state=${currency}&redirect_uri=${redirectUrl}`;
  };

  getStripeCurrency = () => this.currency;

  setStripeCurrency = currency => {
    this.currency = currency;
    this.stripeUrl = this.getStripeUrl(this.currency);
  };

  getStripeId = async () => {
    const authCode = await this.getCodeFromStripe();
    const stripeIdRes = await fetch({
      url: endpoints.getStripeId.url(),
      query: landlordQueries.getStripeId({ input: { currency: this.currency, authCode } }),
    });
    if (
      !stripeIdRes ||
      !stripeIdRes.createConnectedAccount ||
      !stripeIdRes.createConnectedAccount.connectedAccountId
    ) {
      throw new Error('Unexpect Error');
    }
    return stripeIdRes.createConnectedAccount.connectedAccountId;
  };

  getCodeFromStripe = () => {
    window.open(this.stripeUrl);
    if (this.waitingStripeFunc) {
      window.removeEventListener('storage', this.waitingStripeFunc);
    }
    return new Promise(resolve => {
      this.waitingStripeFunc = evt => {
        if (evt?.key === 'STRIPE_CALLBACK_PARAMS') {
          const { error, code, state } = JSON.parse(evt.newValue);
          if (!error && code && state) {
            if (state !== this.currency) {
              console.log('Stripe Error (Currency Change)');
            } else {
              resolve(code);
            }
          } else {
            // errors refers to: https://stripe.com/docs/connect/oauth-reference#get-authorize-error-codes
            console.log('Stripe Error (Stripe callback with error code):', error);
          }
          window.removeEventListener('storage', this.waitingStripeFunc);
          localStorage.setItem('STRIPE_CALLBACK_PARAMS', '{}');
        }
      };
      window.addEventListener('storage', this.waitingStripeFunc);
      setTimeout(() => {
        console.log('Stripe Error (Get stripe auth code timeout)');
        window.removeEventListener('storage', this.waitingStripeFunc);
      }, TIMEOUT);
    });
  };
}
